import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static values = { name: String }
  static targets = [ "container" ]

  connect() {
  }

  // One of the links will be the template
  delete(event) {
    this.nGroupDelete(event.target)
  }

  nGroupDelete(element) {
    const n_group_name = this.nameValue.replace(/n-group-/, '');

    if (confirm('Are you sure?')) {
      var field_group = element.closest('.field-group-entry');
      field_group.remove();
    }

    // The 1 is the template
    if (this.containerTarget.querySelectorAll('.field-group-entry').length == 1) {
      const hidden_destroy_marker = document.createElement('input');
      hidden_destroy_marker.type = 'hidden';
      hidden_destroy_marker.name = 'destroy_' + n_group_name;
      hidden_destroy_marker.className = 'destroy-marker';
      hidden_destroy_marker.value = '1';
      this.containerTarget.appendChild(hidden_destroy_marker);
    }
  };
}
